import React from 'react';

const VerAut1 = ({autorizacUA, styles, handleClickRegr, handleClickUpd, handleClickDel}) => {
  const a200105 = autorizacUA.findIndex( autorizac => autorizac === "200105" );
  const a200110 = autorizacUA.findIndex( autorizac => autorizac === "200110" );

  return (
    <div>
      <button className="ui right labeled icon button fluid" style={styles.titBuscar}>
        <i className="large sitemap yellow icon"></i>
        Opciones
      </button>

      {a200105!==-1 &&
      <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickUpd}>
        <i className="large edit violet icon"></i>
        Modificar
      </button>
      }
      {a200110!==-1 &&
      <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickDel}>
        <i className="large trash alternate violet icon"></i>
        Eliminar
      </button>
      }
      <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickRegr}>
        <i className="large arrow left violet icon"></i>
        Regresar
      </button>
    </div>
  )
};

export default VerAut1
